import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useState } from "react";
import { LockOutlineCloseIcon } from "@jti/brand-icons/lock-outline-close";
import { UiEyeCloseIcon } from "@jti/brand-icons/ui-eye-close";
import { UiEyeOpenIcon } from "@jti/brand-icons/ui-eye-open";
import { usePasswordRules } from "@jti/rest-api";
import { PasswordRequirementsBlock } from "../../components/PasswordRequirementsBlock/PasswordRequirementsBlock";
import { TextInput } from "../Inputs/TextInput";
import styles from "./Password.module.scss";
export const Password = forwardRef(({ withValidationRules, ...props }, ref) => {
    const [isVisible, setIsVisible] = useState(false);
    const { isLoading } = usePasswordRules(withValidationRules);
    const toggleVisibility = useCallback(() => {
        setIsVisible((state) => !state);
    }, []);
    return (_jsxs("div", { className: styles.container, children: [_jsx(TextInput, { ...props, ref: ref, type: isVisible ? "text" : "password", disabled: isLoading && withValidationRules, iconLeft: LockOutlineCloseIcon, iconRight: isVisible ? UiEyeCloseIcon : UiEyeOpenIcon, onRightIconClick: toggleVisibility }), withValidationRules && (_jsx(PasswordRequirementsBlock, { emailValue: props.email, passwordValue: `${props.value || ""}` }))] }));
});
//# sourceMappingURL=Password.js.map